module.exports = __webpack_public_path__ + "media/yir2017-3_720p.46696ebc.webm";